var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockDevices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1429 3H6.85714C5.83147 3 5 3.83147 5 4.85714V18.7857C5 19.8114 5.83147 20.6429 6.85714 20.6429H16.1429C17.1685 20.6429 18 19.8114 18 18.7857V4.85714C18 3.83147 17.1685 3 16.1429 3Z",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94727 17.8516H14.0544",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1406 6.0752C12.1768 6.0825 12.2123 6.09359 12.2471 6.10742C12.3262 6.13889 12.3953 6.18906 12.4551 6.25098L14.2979 8.16113C14.3561 8.22151 14.4036 8.28976 14.4326 8.36719C14.4593 8.43875 14.4717 8.51451 14.4717 8.5918C14.4717 8.66916 14.4594 8.74477 14.4326 8.81641C14.4036 8.89406 14.3563 8.96282 14.2979 9.02344L12.4941 10.8926L14.2969 12.7617C14.3557 12.8222 14.4035 12.8917 14.4326 12.9697C14.4592 13.0412 14.4716 13.1162 14.4717 13.1934C14.4717 13.2707 14.4594 13.3463 14.4326 13.418C14.4036 13.4957 14.3554 13.5637 14.2969 13.624L14.2979 13.625L12.4551 15.5352C12.4252 15.5661 12.393 15.594 12.3584 15.6182L12.2471 15.6787C12.1775 15.7063 12.1048 15.7216 12.0303 15.7217C11.8741 15.7217 11.7347 15.6611 11.6182 15.5557C11.4871 15.437 11.4268 15.2781 11.4268 15.1006V11.999L9.29688 14.208C9.21558 14.2923 9.11157 14.3387 8.99512 14.3447C8.86423 14.3514 8.75103 14.298 8.66406 14.208C8.58095 14.1219 8.5294 14.0139 8.5293 13.8896C8.5293 13.7653 8.58089 13.6575 8.66406 13.5713L11.2471 10.8926L8.66406 8.21484C8.58293 8.13074 8.53963 8.0255 8.53418 7.91016C8.52822 7.78164 8.57708 7.66828 8.66406 7.57812C8.74701 7.49219 8.85397 7.43555 8.98047 7.43555C9.1069 7.43563 9.21398 7.4922 9.29688 7.57812L11.4268 9.78613V6.68555C11.4268 6.508 11.4873 6.34944 11.6182 6.23047C11.7347 6.12453 11.8737 6.06399 12.0303 6.06445L12.1406 6.0752ZM12.3145 14.3838L13.4668 13.1924L12.3145 11.998V14.3838ZM12.3145 9.78613L13.4658 8.5918L12.3145 7.40137V9.78613Z",
    fill: "#313131",
    stroke: "#313131",
    strokeWidth: 0.371429
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockDevices);
export default __webpack_public_path__ + "static/media/lock-devices.b30b32ce.svg";
export { ForwardRef as ReactComponent };